<template>
  <div>
    <!-- <div class="button cta success small import">
      <i class="fa fa-upload"></i>{{ $t('consumer.referrals.export') }}
    </div> -->

    <!-- <div class="search">
      <input type="text" />
      <button class="button xsmall success">{{ $t('consumer.referrals.search') }}</button>
    </div> -->

    <div class="clearfix"></div>

    <table v-if="!isMobile">
      <thead>
        <th>{{ $t('consumer.referrals.id') }}</th>
        <th>{{ $t('consumer.referrals.firstName') }}</th>
        <th>{{ $t('consumer.referrals.lastName') }}</th>
        <th>{{ $t('consumer.referrals.email') }}</th>
        <th>{{ $t('consumer.referrals.mobile') }}</th>
        <th>{{ $t('consumer.referrals.accountCreatedDate') }}</th>
        <th>{{ $t('consumer.referrals.lastTrx') }}</th>
        <th>{{ $t('consumer.referrals.totalTrx') }}</th>
        <th>{{ $t('consumer.referrals.avgRating') }}</th>
        <th>{{ $t('consumer.referrals.referralCode') }}</th>
        <th>{{ $t('consumer.referrals.totalReferral') }}</th>
      </thead>
      <tbody>
        <tr v-for="referral in referrals" v-show="referrals.length > 0">
          <td>
            <a v-bind:href="'/#/' + referral.type + '/' + referral.id">{{ referral.id }}</a>
          </td>
          <td>{{ referral.firstName }}</td>
          <td>{{ referral.lastName }}</td>
          <td>{{ referral.email }}</td>
          <td>{{ referral.mobile }}</td>
          <td>{{ referral.accountCreated }}</td>
          <td>{{ referral.lastTrx }}</td>
          <td>{{ referral.totalTrx }}</td>
          <td>{{ referral.rating }}</td>
          <td>{{ referral.referralCode }}</td>
          <td>{{ referral.totalReferral }}</td>
        </tr>

        <tr v-show="loading">
          <td colspan="11" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ $t('consumer.ratings.loading') }}
          </td>
        </tr>

        <tr v-show="referrals.length === 0 && !loading">
          <td colspan="11" class="table-block">
            {{ $t('consumer.referrals.emptyState') }}
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div v-if="referrals.length > 0">
        <div class="cards" v-for="(referral, i) in referrals" :key="i">
          <div class="card">
            <div>
              <span>{{ $t('consumer.referrals.id') }}:</span> <strong><a v-bind:href="'/#/' + referral.type + '/' + referral.id">{{ referral.id }}</a></strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.firstName') }}:</span> <strong>{{ referral.firstName }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.email') }}:</span> <strong>{{ referral.email }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.mobile') }}:</span> <strong>{{ referral.mobile }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.accountCreatedDate') }}:</span> <strong>{{ referral.accountCreated }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.lastTrx') }}:</span> <strong>{{ referral.lastTrx }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.totalTrx') }}:</span> <strong>{{ referral.totalTrx }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.avgRating') }}:</span> <strong>{{ referral.rating }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.referralCode') }}:</span> <strong>{{ referral.referralCode }}</strong>
            </div>
            <div>
              <span>{{ $t('consumer.referrals.totalReferral') }}:</span> <strong>{{ referral.totalReferral }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        {{ $t('consumer.referrals.emptyState') }}
      </div>
    </div>
  </div>
</template>

<script>
import ApiReferrals from '../../modules/api/consumer/referrals'

export default {
  name: 'referrals',
  props: ['conId', 'isMobile'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    referrals () {
      return this.$store.state.consumer.referrals.list
    },
    isMax () {
      return this.$store.state.consumer.referrals.isMax
    }
  },
  methods: {
    init () {
      this.$store.commit('consumer/resetReferrals')
      this.$store.commit('consumer/setReferralsIsMax', false)
      this.$store.commit('consumer/setReferralsCurrentPage', 0)

      this.getReferrals()
    },
    getReferrals () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiReferrals.getReferrals(self, self.conId, function () {
        self.loading = false
      })
    }
  },
  watch: {
    conId: function (value) {
      this.init()
    },
    isMobile: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.search{
  box-sizing: border-box;
  display: flex;
  width: 400px;

  input{
    display: inline-block;
    vertical-align: middle;
    margin-top: 0;
    border-radius: 5px 0 0 5px;
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
  }
}

.import{
  float: right;
  .fa{ margin-right: 5px; }
}

.clearfix{ clear: both; }

.hideMobile {
  display: none;
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }
}

@media only screen and (max-width: 430px) {
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      span {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/Referrals.vue